import { render, staticRenderFns } from "./VDIs.vue?vue&type=template&id=5ea2dcee&scoped=true&"
import script from "./VDIs.vue?vue&type=script&lang=ts&"
export * from "./VDIs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea2dcee",
  null
  
)

export default component.exports